import { Component, Input, Output, OnInit, EventEmitter, OnChanges } from '@angular/core';
import { PagedResult } from '../../model/generic-paged-result.model';

@Component({
  selector: 'wl-paging-controls',
  templateUrl: 'paging-controls.component.html',
  styleUrls: ['paging-controls.component.css'],
    standalone: false
})
export class PagingControlsComponent implements OnInit, OnChanges {
  @Input('pagedResult') public pagedResult: PagedResult<any>;
  public resultsArray: Array<any>;
  public showFirstLink = false;
  public showLastLink = false;
  public maxDisplayedPages = 7;

  @Output() pagingEvent: EventEmitter<any> = new EventEmitter();

  public constructor() {}

  ngOnInit() {
    this.getPagesToDisplay();
  }

  private getPagesToDisplay() {
    const steps = new Array<any>(Math.min(this.pagedResult.TotalPages, this.maxDisplayedPages));
    const currentPage = this.pagedResult.CurrentPageNumber;
    let start = Math.max(1, currentPage - Math.floor(this.maxDisplayedPages / 2));
    if (start + steps.length > this.pagedResult.TotalPages) {
      start = this.pagedResult.TotalPages - (steps.length - 1);
    }
    this.showFirstLink = start > 1;
    this.showLastLink = start + steps.length <= this.pagedResult.TotalPages;
    this.resultsArray = [];
    for (let i = start; i < start + Math.min(this.maxDisplayedPages, this.pagedResult.TotalPages); i++) {
      this.resultsArray.push(i);
    }
  }

  ngOnChanges() {
    this.getPagesToDisplay();
  }

  public pagingEventClick(page: number) {
    if (!(page < 1) && !(page > this.pagedResult.TotalPages)) {
      this.pagingEvent.emit(page);
    }
  }
}
